import * as yup from 'yup';

export const UpdateClientSchema = yup.object({
  id: yup.string().required(),
});
export type IUpdateClient = yup.InferType<typeof UpdateClientSchema>;

export const ClientSchema = yup.object({
  clientId: yup.string().required(),
  secret: yup.string().required(),
});
export type IClient = yup.InferType<typeof ClientSchema>;
